import React from 'react';
import { Col, Row } from 'reactstrap';
import { useDispatch } from 'react-redux';
import AutoComplete from 'components/molecules/autocompleteFilter';
import forms from 'constants/forms';
import TimeFilter from 'components/organisms/timeFilter';

const DEFAULT_FILTER = forms.patientFilterOptions[0];

const Sorting = () => {
  const {
    compliance: { applyTimeFilter, applyFilters },
  } = useDispatch();

  const filter = DEFAULT_FILTER;

  const handleSubmit = (dates) => {
    applyTimeFilter(dates);
  };

  const handleOnChange = (option) => {
    if (option) {
      applyFilters({ patientGuid: option.value });
    }
  };
  return (
    <Row>
      <Col xl="2" xs="12" md="6">
        <p>Report Time Window</p>
        <TimeFilter handleSubmit={handleSubmit} />
      </Col>
      <Col xl="2" xs="12" md="6">
        <p>Patient Name</p>
        <AutoComplete filter={filter} handleClick={handleOnChange} />
      </Col>
    </Row>
  );
};

export default Sorting;
